export const DEFAULT_TRADE_SERVICE_URL = "https://futures.bushelops.com/";
export const BASE_URL =
  process.env.REACT_APP_TRADE_SERVICE_BASE_URL ?? DEFAULT_TRADE_SERVICE_URL;
export const CASH_BIDS_ENDPOINT = "api/v1/cash-bids";
